<template>
    <main id="main">
        <section class="login-section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-8 col-xl-5">
                        <div class="min-height-100vh has-header d-flex align-items-center">
                            <div class="form-content form-team-content w-100 white-content">
                                <img src="https://www.compralaentrada.com/logos_cle/CLEORIGINAL.png" alt="Compralaentrad" class="w-100"/>
                                <div class="w-100 mt-3">
                                    <h2>¡Lamentamos las molestias!</h2>
                                    <p>Esta web se encuentra en mantenimiento.</p>
                                    <p>Pronto volverá a estar disponible.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>    
</template>

<script>
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        created() {
            useHead('Mantenimiento');
        }
    }
</script>

<style scoped>
    .min-height-100vh.has-header {
        min-height: calc(100vh - 91px);
    }
    .w-100 {
        width: 100%!important;
    }
</style>
